import { PARTNER_ID, WIDGET_DOMAIN } from '~/helpers/constants';

export const partnerWidgetMatch = (partnerId?: string, widgetUrl?: null | string) => {
  return (
    (partnerId === PARTNER_ID.ZENCHEF && widgetUrl?.includes(WIDGET_DOMAIN.ZENCHEF)) ||
    (partnerId === PARTNER_ID.THEFORK && widgetUrl?.includes(WIDGET_DOMAIN.THEFORK)) ||
    (partnerId === PARTNER_ID.OPENTABLE && widgetUrl?.includes(WIDGET_DOMAIN.OPENTABLE)) ||
    (partnerId === PARTNER_ID.SEVENROOMS && widgetUrl?.includes(WIDGET_DOMAIN.SEVENROOMS))
  );
};
